module.exports = __webpack_public_path__ + "img/charity_3.3752e090.png";